module.exports = __webpack_public_path__ + "img/role4.7aaf8248.png";